<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M18.666 16.307V7.692c0-1.586-1.194-2.872-2.666-2.872-1.473 0-2.667 1.286-2.667 2.872v8.615c0 1.586 1.194 2.872 2.667 2.872 1.472 0 2.666-1.286 2.666-2.872zM16 2.666c-2.578 0-4.667 2.25-4.667 5.026v8.615c0 2.776 2.09 5.026 4.667 5.026s4.666-2.25 4.666-5.026V7.692c0-2.776-2.089-5.026-4.666-5.026z" clip-rule="evenodd"/><path d="M12.333 28.333a1 1 0 011-1h5.333a1 1 0 110 2h-5.333a1 1 0 01-1-1zm11.333-13.667a1 1 0 00-1 1v1a6.667 6.667 0 11-13.333 0v-1a1 1 0 10-2 0v1A8.667 8.667 0 0015 25.275v2.058h2v-2.058a8.667 8.667 0 007.666-8.609v-1a1 1 0 00-1-1z"/></svg>
</template>

<script>
export default {
  name: 'objectsMicrophoneOutline'
}
</script>
